import PropTypes from "prop-types";
import React from "react";
import { SelectionControlGroup } from "react-md";
import DialogContainer from "react-md/lib/Dialogs";
import Button from "react-md/lib/Buttons/Button";
import ReadOnlyField from "components/Shared/ReadOnlyField";
import logo from "static/images/logo.png";
import AppInsightsTracker from "components/Shared/AppInsightsTracker";
import {MSpinner} from "components/Shared";

class WaiverDetails extends AppInsightsTracker {
  constructor(props, context) {
    super(props, context);
    this.displayName = "WaiverDetails";
    this.showActionDialog = this.showActionDialog.bind(this);
    this.hideActionDialog = this.hideActionDialog.bind(this);
    this.isVisible = this.isVisible.bind(this);
    this.confirmHandler = this.confirmHandler.bind(this);

    this.submitHandler = this.submitHandler.bind(this);
    this.onEligibleChanged = this.onEligibleChanged.bind(this);
    this.state = {
      eligible: "",
      showThankyou: false,
      actionDialogVisible: false
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.waiver) {
      this.setState({ showThankyou: nextProps.waiver.message === "" });
    }
  }

  isVisible() {
    return this.state.actionDialogVisible;
  }
  showActionDialog() {
    this.setState({ actionDialogVisible: true });
  }

  hideActionDialog() {
    this.setState({ actionDialogVisible: false });
  }

  onEligibleChanged(val) {
    this.setState({ eligible: val });
  }

  submitHandler() {
    this.showActionDialog();
  }

  confirmHandler() {
    const dto = {
      controlIdNumber: this.props.waiver.controlIdNumber,
      eligible: this.state.eligible === "1"
    };
    this.props.onDecisionClick(dto);
    setTimeout(() => { this.hideActionDialog(); }, 1000);
  }

  render() {
    const { isFetching, waiver } = this.props;
    if (isFetching) {
      return <MSpinner/>;
    }

    const methods = [];
    methods.push({ secondary: true, children: "Cancel", onClick: this.hideActionDialog });
    methods.push(<Button raised primary onClick={this.confirmHandler}>OK</Button>);

    const hasError = waiver.errorCode !== 0;

    return (
      <div id="waiver-decision" className="md-grid md-cell waiver-wrapper">
        <div className="waiver-form">
          <img src={logo} alt="logo.png" className="mueller-logo" />
          <h3 className="mueller-title" data-test="title">Value Verify Result</h3>

          {hasError
            ?
            <div>
              <div className="waiver-error">
                There was an error processing the request.
              </div>
              <br />
              <div>If you have any questions regarding this order please contact Mueller Customer Service at customerservice@muellerreports.com.</div>
            </div>
            :
            <div>
              <ReadOnlyField title="Address" fieldValue={waiver.address} />
              <ReadOnlyField title="Loan Number" fieldValue={waiver.loanNumber} />
              <ReadOnlyField title="DU Casefile ID" fieldValue={waiver.duNumber ? waiver.duNumber : "N/A"} />
              <br />

              {waiver.handled
                ? <div className="waiver-handled">
                  <div>{waiver.successMessage}</div>
                  <br />
                  <div>If you have any questions regarding this order please contact Mueller Customer Service at customerservice@muellerreports.com.</div>
                </div>
                : <div>
                  <SelectionControlGroup
                    id="selection-control-group-eligible"
                    name="radio-eligible"
                    type="radio"
                    label="Elect the Value Verify result."
                    defaultValue=""
                    onChange={this.onEligibleChanged}
                    controls={[
                      { label: `${waiver.eligibleText}`, value: "1" },
                      { label: `${waiver.ineligibleText}`, value: "0" }
                    ]}
                  />
                  <Button
                    onClick={this.submitHandler}
                    primary
                    raised
                    type="submit"
                    children="SUBMIT"
                    className="full-width m-t-10"
                    disabled={this.state.eligible === ""}
                  />
                </div>
              }

              <DialogContainer
                id={"action-waiver-dialog"}
                visible={this.isVisible()}
                onHide={this.hideActionDialog}
                actions={methods}
                title={"Confirm Value Verify result"}
                width={400}
              >
                <div>
                  <p>Are your sure you want to continue?</p>
                </div>
              </DialogContainer>
            </div>
          }

        </div>
      </div>
    );
  }
}

WaiverDetails.propTypes = {
  waiver: PropTypes.object.isRequired,
  isFetching: PropTypes.bool.isRequired,
  onDecisionClick: PropTypes.func.isRequired,
};
export default WaiverDetails;